(() => {
  'use strict';
  const strings = () => JSON.parse(document.getElementById('StudioStrings')?.textContent || '{}');
  const root = () => window.Shopify?.routes?.root || '/';
  const endpoint = (path) => `${root()}${path}`;
  const status = (message) => { const el = document.querySelector('[data-studio-status]'); if (el) el.textContent = message; };
  let busy = false;
  let returnFocus = null;
  const closeDialog = (dialog) => { if (!dialog?.open) return; dialog.close(); };
  const openDialog = (dialog, source) => {
    if (!dialog) return;
    document.querySelectorAll('.studio-dialog[open]').forEach(el => el.close());
    returnFocus = source || document.activeElement;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    dialog.querySelector('[data-dialog-close]')?.focus();
  };
  const setError = (scope, message) => { const el = scope.querySelector('.studio-form-error, .studio-cart-error'); if (el) { el.textContent = message; el.hidden = false; } };
  async function jsonRequest(url, data) {
    const response = await fetch(url, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify(data)});
    const result = await response.json();
    if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : typeof result.message === 'string' ? result.message : strings().cartError);
    return result;
  }
  async function refreshCart() {
    const sectionNodes = [...document.querySelectorAll('[data-cart-section]')];
    const ids = [...new Set(sectionNodes.map(el => el.dataset.cartSection))];
    const url = new URL(document.body.dataset.studioCartUrl || endpoint('cart'), location.origin);
    url.searchParams.set('sections', ids.join(','));
    const [sectionResponse, cartResponse] = await Promise.all([fetch(url), fetch(endpoint('cart.js'))]);
    if (!sectionResponse.ok || !cartResponse.ok) throw new Error(strings().cartError);
    const [sections, cart] = await Promise.all([sectionResponse.json(), cartResponse.json()]);
    for (const node of sectionNodes) {
      const html = sections[node.dataset.cartSection];
      if (!html) throw new Error(strings().cartError);
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const content = parsed.querySelector('[data-cart-content]');
      if (!content) throw new Error(strings().cartError);
      node.querySelector('[data-cart-content]')?.replaceWith(content);
      node.querySelectorAll('[data-cart-total-count]').forEach(el => { el.textContent = cart.item_count; });
    }
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count ? ` (${cart.item_count})` : ''; });
    return cart;
  }
  const cartDestination = (source) => {
    if (document.body.dataset.studioCart === 'page') { location.assign(document.body.dataset.studioCartUrl || endpoint('cart')); return; }
    openDialog(document.getElementById('StudioCart'), source);
  };
  async function addProduct(form, submitter) {
    if (busy || !submitter?.value) return;
    busy = true;
    const buttons = [...form.elements].filter(el=>el.tagName==='BUTTON' && el.type==='submit' && !el.disabled);
    buttons.forEach(el => { el.disabled = true; });
    form.setAttribute('aria-busy','true');
    let added = false;
    try {
      const data = new FormData(form);
      const item = {id:submitter.value, quantity:Number(data.get('quantity') || 1)};
      if (data.get('selling_plan')) item.selling_plan = data.get('selling_plan');
      const properties = {};
      for (const [name,value] of data.entries()) if (name.startsWith('properties[')) properties[name.slice(11,-1)] = value;
      if (Object.keys(properties).length) item.properties = properties;
      await jsonRequest(endpoint('cart/add.js'), {items:[item]});
      added = true;
      if (document.body.dataset.studioCart !== 'page') await refreshCart();
      closeDialog(form.closest('dialog'));
      cartDestination(document.querySelector('[data-primary-buy] button') || document.querySelector('[data-cart-open]'));
      status(strings().added);
      document.dispatchEvent(new CustomEvent('studio:cart-updated', {detail:{variantId:item.id}}));
    } catch (error) {
      if (added) location.assign(document.body.dataset.studioCartUrl || endpoint('cart'));
      else { setError(form, error.message || strings().addError); if(submitter && !form.contains(submitter)) form.querySelector('.studio-form-error')?.scrollIntoView({block:'center',behavior:'smooth'}); }
    } finally { buttons.forEach(el => { el.disabled = false; }); form.removeAttribute('aria-busy'); busy = false; }
  }
  async function changeCart(key, quantity, scope) {
    if (busy) return;
    busy = true;
    scope?.setAttribute('aria-busy','true');
    try { await jsonRequest(endpoint('cart/change.js'), {id:key,quantity:Math.max(0,quantity)}); await refreshCart(); }
    catch (error) { if (scope) setError(scope,error.message || strings().cartError); }
    finally { scope?.removeAttribute('aria-busy'); busy = false; }
  }
  async function toggleProtection(input) {
    if (busy) { input.checked = !input.checked; return; }
    busy = true;
    const scope = input.closest('[data-cart-content]');
    scope?.setAttribute('aria-busy','true');
    const checked = input.checked;
    try {
      const response = await fetch(endpoint('cart.js'));
      if (!response.ok) throw new Error(strings().cartError);
      const cart = await response.json();
      const matching = cart.items.filter(item => String(item.variant_id) === input.dataset.protectionVariant);
      if (checked && !matching.length) await jsonRequest(endpoint('cart/add.js'), {items:[{id:input.dataset.protectionVariant,quantity:1}]});
      if (!checked && matching.length) { const updates={}; matching.forEach(item=>{updates[item.key]=0;}); await jsonRequest(endpoint('cart/update.js'), {updates}); }
      await refreshCart();
    } catch(error) { input.checked = !checked; if(scope) setError(scope,error.message || strings().cartError); }
    finally { scope?.removeAttribute('aria-busy'); busy=false; }
  }
  const railControllers = new WeakMap();
  function initAutoRail(rail) {
    if (railControllers.has(rail)) return;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const abort = new AbortController();
    const options = {signal:abort.signal};
    let frame = 0, previous = 0, position = rail.scrollLeft, direction = 1;
    let visible = false, dragging = false, keyboardFocused = false, pointerFocus = false;
    const speed = Math.min(100,Math.max(10,Number(rail.dataset.scrollSpeed) || 30));
    const canRun = () => visible && !motion.matches && !keyboardFocused && !dragging && !document.hidden;
    function sync() {
      if (canRun() && !frame) { previous = 0; position = rail.scrollLeft; frame = requestAnimationFrame(tick); }
      else if (!canRun() && frame) { cancelAnimationFrame(frame); frame = 0; }
    }
    function tick(now) {
      frame = 0;
      if (!rail.isConnected) { destroy(); return; }
      if (!canRun()) return;
      const elapsed = previous ? Math.min((now - previous)/1000,.05) : 0;
      previous = now;
      const max = Math.max(0,rail.scrollWidth - rail.clientWidth);
      if (Math.abs(rail.scrollLeft-position)>2) position=rail.scrollLeft;
      if (max > 0 && !document.querySelector('.studio-dialog[open]')) {
        position = Math.min(max,Math.max(0,position + direction * speed * elapsed));
        rail.scrollLeft = position;
        if (position >= max) direction = -1;
        else if (position <= 0) direction = 1;
      } else position = rail.scrollLeft;
      frame = requestAnimationFrame(tick);
    }
    rail.addEventListener('pointerdown',()=>{pointerFocus=true;keyboardFocused=false;dragging=true;sync();},options);
    const release=()=>{if(dragging){dragging=false;position=rail.scrollLeft;sync();}};
    window.addEventListener('pointerup',release,options);
    window.addEventListener('pointercancel',release,options);
    window.addEventListener('blur',release,options);
    document.addEventListener('keydown',event=>{if(event.key==='Tab'){pointerFocus=false;if(rail.contains(document.activeElement)){keyboardFocused=true;sync();}}},options);
    rail.addEventListener('focusin',()=>{keyboardFocused=!pointerFocus;sync();},options);
    rail.addEventListener('focusout',event=>{keyboardFocused=!pointerFocus&&rail.contains(event.relatedTarget);sync();},options);
    document.addEventListener('visibilitychange',sync,options);
    motion.addEventListener('change',sync,options);
    const observer = new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();},{threshold:0});
    function destroy() { cancelAnimationFrame(frame);observer.disconnect();abort.abort();railControllers.delete(rail); }
    railControllers.set(rail,{destroy});
    observer.observe(rail);
  }

  let mastheadController;
  function initMasthead() {
    const masthead=document.querySelector('[data-studio-masthead]');
    const nav=masthead?.querySelector('[data-studio-nav]');
    if(!masthead||!nav){mastheadController?.destroy();mastheadController=null;return;}
    if(mastheadController?.nav===nav) return;
    mastheadController?.destroy();
    const abort=new AbortController();
    const options={signal:abort.signal,passive:true};
    let frame=0;
    function measure(){
      const navHeight=nav.getBoundingClientRect().height;
      if(navHeight>0)masthead.style.setProperty('--studio-nav-height',`${navHeight}px`);
      document.documentElement.style.setProperty('--studio-masthead-height',`${masthead.getBoundingClientRect().height}px`);
    }
    function update(){frame=0;masthead.classList.toggle('is-scrolled',window.scrollY>8);}
    function schedule(){if(!frame)frame=requestAnimationFrame(update);}
    const resize=new ResizeObserver(measure);
    resize.observe(nav);resize.observe(masthead);
    window.addEventListener('scroll',schedule,options);
    window.addEventListener('pageshow',update,options);
    window.addEventListener('resize',measure,options);
    measure();update();
    mastheadController={nav,destroy(){abort.abort();resize.disconnect();cancelAnimationFrame(frame);}};
  }

  function selectHeroSlide(hero,index) {
    if(!hero) return;
    hero.querySelectorAll('[data-hero-slide]').forEach((slide,i)=>{
      const active=i===index;
      slide.classList.toggle('is-active',active);
      slide.toggleAttribute('inert',!active);
      if(active) slide.querySelectorAll('img').forEach(img=>{img.loading='eager';});
    });
    hero.querySelectorAll('[data-hero-index]').forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
  }

  const slideshowControllers = new WeakMap();
  function initSlideshow(el) {
    if(slideshowControllers.has(el)) return;
    const hero=el.hasAttribute('data-hero');
    const slides=[...el.querySelectorAll(hero?'[data-hero-slide]':'.studio-announcement-slide')];
    if(slides.length<2) return;
    const abort=new AbortController(),options={signal:abort.signal};
    const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
    const interval=Math.max(2,Math.min(15,Number(el.dataset.interval)||3))*1000;
    let index=Math.max(0,slides.findIndex(slide=>slide.classList.contains('is-active')));
    let timer=0,visible=false,focused=false,editorSelected=false,paused=false;
    const canRun=()=>el.dataset.autoplay==='true'&&!motion.matches&&!document.hidden&&visible&&!focused&&!editorSelected&&!paused;
    function schedule(){clearTimeout(timer);timer=0;if(canRun())timer=setTimeout(()=>{select(index+1);},interval);}
    function select(i){
      index=(i+slides.length)%slides.length;
      if(hero)selectHeroSlide(el,index);
      else slides.forEach((slide,j)=>{slide.classList.toggle('is-active',j===index);slide.toggleAttribute('inert',j!==index);});
      el.classList.add('studio-slideshow-ready');
      schedule();
    }
    el.addEventListener('click',event=>{
      const button=event.target.closest('button');if(!button)return;
      if(button.hasAttribute('data-hero-index'))select(Number(button.dataset.heroIndex));
      if(button.hasAttribute('data-announcement-prev'))select(index-1);
      if(button.hasAttribute('data-announcement-next'))select(index+1);
      if(button.hasAttribute('data-slideshow-pause')){
        paused=!paused;button.setAttribute('aria-pressed',String(paused));
        button.querySelector('[data-slideshow-pause-label]').hidden=paused;
        button.querySelector('[data-slideshow-resume-label]').hidden=!paused;schedule();
      }
    },options);
    el.addEventListener('focusin',()=>{focused=true;schedule();},options);
    el.addEventListener('focusout',event=>{focused=el.contains(event.relatedTarget);schedule();},options);
    el.addEventListener('shopify:block:select',event=>{const selected=slides.indexOf(event.target.closest(hero?'[data-hero-slide]':'.studio-announcement-slide'));if(selected>=0){editorSelected=true;select(selected);}},options);
    el.addEventListener('shopify:block:deselect',()=>{editorSelected=false;schedule();},options);
    document.addEventListener('visibilitychange',schedule,options);
    motion.addEventListener('change',schedule,options);
    const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;schedule();},{threshold:0});
    slideshowControllers.set(el,{destroy(){clearTimeout(timer);observer.disconnect();abort.abort();slideshowControllers.delete(el);}});
    observer.observe(el);
  }

  function init(scope=document) {
    initMasthead();
    scope.querySelectorAll('[data-slideshow]').forEach(initSlideshow);
    scope.querySelectorAll('[data-auto-rail]').forEach(initAutoRail);
    scope.querySelectorAll('.studio-dialog:not([data-bound])').forEach(dialog=>{
      dialog.dataset.bound='true';
      dialog.addEventListener('close',()=>{ if(!document.querySelector('.studio-dialog[open]')){ document.documentElement.style.overflow='';if(returnFocus?.isConnected) returnFocus.focus(); } });
      dialog.addEventListener('click',event=>{ if(event.target!==dialog) return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)closeDialog(dialog); });
    });
    scope.querySelectorAll('[data-gallery]:not([data-bound])').forEach(gallery=>{
      gallery.dataset.bound='true';gallery.addEventListener('scroll',()=>{const count=gallery.parentElement.querySelector('[data-gallery-count]');if(count)count.textContent=`${Math.round(gallery.scrollLeft/(gallery.clientWidth+4))+1} / ${gallery.children.length}`;},{passive:true});
    });
    scope.querySelectorAll('[data-primary-buy]:not([data-bound])').forEach(el=>{
      el.dataset.bound='true';const sticky=document.querySelector('[data-sticky-buy]');
      if(sticky)new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting||entries[0].boundingClientRect.top>0;}).observe(el);
    });
    scope.querySelectorAll('[data-recommendations-url]:not([data-bound])').forEach(el=>{
      el.dataset.bound='true';const observer=new IntersectionObserver(async entries=>{
        if(!entries[0].isIntersecting)return;observer.disconnect();
        try{const response=await fetch(el.dataset.recommendationsUrl);if(!response.ok)return;const html=new DOMParser().parseFromString(await response.text(),'text/html');const content=html.querySelector('[data-recommendations-content]');if(content){el.replaceChildren(content);init(el);}}catch{}
      },{rootMargin:'500px'});observer.observe(el);
    });
  }
  document.addEventListener('submit',event=>{
    if(event.target.matches('.studio-add-form')){event.preventDefault();addProduct(event.target,event.submitter);}
  });
  document.addEventListener('click',async event=>{
    const target=event.target.closest('button,a');if(!target)return;
    if(target.hasAttribute('data-dialog-open')){event.preventDefault();openDialog(document.getElementById(target.dataset.dialogOpen),target);}
    if(target.hasAttribute('data-dialog-close')){event.preventDefault();closeDialog(target.closest('dialog'));}
    if(target.hasAttribute('data-cart-open')&&document.body.dataset.studioCart==='drawer'){
      event.preventDefault();openDialog(document.getElementById('StudioCart'),target);
      try{await refreshCart();}catch{location.assign(target.href);}
    }
    if(target.hasAttribute('data-image-zoom')){
      const image=document.querySelector('[data-zoom-image]');image.src=target.dataset.imageZoom;image.alt=target.querySelector('img')?.alt||'';openDialog(document.getElementById('StudioZoom'),target);
    }
    if(target.hasAttribute('data-quantity-step')){
      const input=target.closest('.studio-quantity').querySelector('input');const next=Math.max(0,Number(input.value)+Number(target.dataset.quantityStep));await changeCart(input.dataset.lineKey,next,target.closest('[data-cart-content]'));
    }
    if(target.hasAttribute('data-cart-remove')){event.preventDefault();await changeCart(target.dataset.cartRemove,0,target.closest('[data-cart-content]'));}
    if(target.hasAttribute('data-gallery-step')){const gallery=target.closest('.studio-product').querySelector('[data-gallery]');gallery.scrollBy({left:(gallery.clientWidth+4)*Number(target.dataset.galleryStep),behavior:'smooth'});}
    if(target.hasAttribute('data-rail-step')){const rail=target.closest('[data-recommendations-content]').querySelector('[data-product-rail]');rail?.scrollBy({left:rail.clientWidth*Number(target.dataset.railStep),behavior:'smooth'});}
    if(!target.closest('.studio-mega')) document.querySelectorAll('.studio-mega[open]').forEach(el=>el.removeAttribute('open'));
  });
  document.addEventListener('change',event=>{
    const input=event.target;
    if(input.matches('[data-line-key]')){if(Number.isInteger(Number(input.value)))changeCart(input.dataset.lineKey,Number(input.value),input.closest('[data-cart-content]'));}
    if(input.matches('[data-protection-variant]'))toggleProtection(input);
    if(input.matches('[data-localization],[data-filter-sort]'))input.form.requestSubmit();
  });
  document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.studio-mega[open]').forEach(el=>el.removeAttribute('open'));});
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>{event.target.querySelectorAll('[data-slideshow]').forEach(el=>slideshowControllers.get(el)?.destroy());event.target.querySelectorAll('[data-auto-rail]').forEach(rail=>railControllers.get(rail)?.destroy());if(mastheadController&&event.target.contains(mastheadController.nav)){mastheadController.destroy();mastheadController=null;}});
  document.addEventListener('shopify:block:select',event=>{const slide=event.target.closest('[data-hero-slide]');if(slide){const hero=slide.closest('[data-hero]');selectHeroSlide(hero,[...hero.querySelectorAll('[data-hero-slide]')].indexOf(slide));}const row=event.target.closest('.studio-collapsible-row');if(row)row.open=true;});
  document.addEventListener('DOMContentLoaded',()=>init(),{once:true});
})();
